import React, { useEffect } from 'react'
import { Box } from '@mui/material'
import { GoogleLoginButton } from 'infrastructure/googleDrive'
import { SheetSelection } from '../../components/tree/summaries/SheetSelection'
import { TreesTable } from './TreesTable'
import { SelectedMasterData } from './SelectedMasterData'
import { useUrlSearchParam } from 'shared/hooks'
import {
  SheetParamKey,
  TreeParamKey,
} from '../../components/tree/summaries/types'
import { useSetAtom } from 'infrastructure/state/jotai.wrapper'
import { currentSelectedMasterAtom } from './atoms'
import { useSummaryDataForCurrentSheet } from '../../components/tree/summaries/hooks'

export function SummaryValidation() {
  const [sheetId] = useUrlSearchParam(SheetParamKey)
  const [treeId] = useUrlSearchParam(TreeParamKey)
  useSetAtom(currentSelectedMasterAtom)(treeId ?? '')

  const getSheet = useSummaryDataForCurrentSheet()

  useEffect(() => {
    getSheet(sheetId)
  }, [getSheet, sheetId])

  return (
    <Box>
      Use this tool to check all summaries for a selected summary tab.
      <GoogleLoginButton LoggedInComponent={SummariesValidation} />
    </Box>
  )
}

export function SummariesValidation() {
  return (
    <Box>
      <Box>Summaries</Box>
      <SheetSelection />
      <TreesTable />
      <SelectedMasterData />
    </Box>
  )
}
